import { useEffect, useRef, useState } from 'react'

const useInview = () => {
  const [inView, setInview] = useState(false)
  const ref = useRef(null)
  useEffect(() => {
    const el = ref.current
    const observer = new IntersectionObserver((entries) => {
      setInview(entries[0].isIntersecting)
    })

    if (el) observer.observe(el)

    return () => {
      if (el) observer.unobserve(el)
    }
  }, [])

  return { inView, ref }
}

export default useInview